// extracted by mini-css-extract-plugin
module.exports = {"innerContainer":"UsersCard_innerContainer__2pIzA","usersInfo":"UsersCard_usersInfo__2CTsB","label":"UsersCard_label__PVvaB","values":"UsersCard_values__2AF90"};